// extracted by mini-css-extract-plugin
export default {"root":"OLL_AN9TI7j9iosIUBu1","loading":"mzQGtL316B2XeijTRV9v","card":"pI46tg4MBEVpl_4hZFnd","placeHolderShimmer":"TcB3kjTXFrhzF9AFHQNf"};